export function polyfill() {
  if (!Element.prototype.matches) {
    const elProt = Element.prototype as any;
    Element.prototype.matches = elProt.msMatchesSelector || elProt.webkitMatchesSelector;
  }

  if (!Element.prototype.closest) {
    Element.prototype.closest = function <K extends keyof HTMLElementTagNameMap>(s: K) {
      var el = this;

      do {
        if (el.matches(s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }
}
